import { initAccordion } from '../../components/accordion';

export default () => {
  if (!$('.customer-care__main.has-accordion').length) {
    return;
  }

  initAccordion('[data-customer-care-accordion]');
};
